import script from "./UiVehicles.vue?vue&type=script&setup=true&lang=js"
export * from "./UiVehicles.vue?vue&type=script&setup=true&lang=js"

import "./UiVehicles.vue?vue&type=style&index=0&id=ef4f7b78&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-ef4f7b78"]])

export default __exports__